import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArkUnitOfWork, AppInformationService } from 'app/core/core.module';
import { Pledge, PledgeLine } from 'app/core/model/entity-model';

@Component({
    selector: 'app-pledge-detail',
    templateUrl: './pledge-detail.component.html',
    styleUrls: ['./pledge-detail.component.scss'],
    standalone: false,
})
export class PledgeDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    pledge: Pledge;
    pledgeId: number;
    people: any[];

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, public appInfo: AppInformationService) {}

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        this.people = await this.uow.getPeopleForGiving();
        if (!this.pledgeId) {
            this.pledge = this.uow.pledges.createEntity();
            this.pledge.date = new Date();
        } else {
            this.pledge = await this.uow.pledges.byId(this.pledgeId, 'lines');
        }
        for (let i = this.pledge.lines.length; i < 6; i++) {
            this.addLine();
        }
        this.appInfo.pleaseWaitHide();
    }

    addLine() {
        this.pledge.lines.push(this.uow.manager.createEntity('PledgeLine') as PledgeLine);
    }

    async save() {
        this.pledge.lines.slice().forEach(line => {
            if (line.amount == null) line.amount = 0;
            if (!line.amount && !line.expectedDate) line.entityAspect.setDeleted();
        });

        await this.uow.commit();
        this.result.next({ result: true });
        this.modalRef.hide();
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }
}
